import { createApp } from 'vue'
import router from '@/router/router.js'
import App from './App.vue'

import api from './http/api'
import http from './http/http'
import './http/axios'

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
})

const app = createApp(App)
app.config.globalProperties.$router = router
// 对后端接口 进行全局注册
app.config.globalProperties.$api = api
// 对请求方式 进行全局注册
app.config.globalProperties.$http = http


app.use(router)
app.mount('#app')
